"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkReadingFlag = checkReadingFlag;
exports.comparePassword = comparePassword;
exports.makeFilePath = makeFilePath;
exports.makeFirebaseStorageUrl = makeFirebaseStorageUrl;
exports.makePasswordHash = makePasswordHash;
exports.zeropadding = zeropadding;
require("core-js/modules/es6.number.constructor");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _bcryptjs = _interopRequireDefault(require("bcryptjs"));
var _auth = require("@/utils/auth");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _recruitmentQuery = require("@/apollo/queries/recruitment-query");
/**
 * @param {Int} num
 * @returns {Int} length
 */
function zeropadding(num, length) {
  return "00000".concat(num).slice(-length);
}
function makeFilePath(rootPath, fileName) {
  if (!rootPath || !fileName) {
    return '';
  }
  return "".concat(rootPath, "_").concat(fileName);
}
function makeFirebaseStorageUrl(path) {
  return "".concat(process.env.VUE_APP_FIREBASE_STORAGE_URI).concat(path);
}
function makePasswordHash(pass) {
  return _bcryptjs.default.hashSync(pass, process.env.VUE_BCRYPT_STRETCH);
}
function comparePassword(pass, passHash) {
  return _bcryptjs.default.compare(pass, passHash);
}
function checkReadingFlag(_x) {
  return _checkReadingFlag.apply(this, arguments);
}
function _checkReadingFlag() {
  _checkReadingFlag = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
    var find, res, res1, res2, res3, res4, res5;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(value === false)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", false);
        case 1:
          find = false; // 個別契約書
          _context.next = 2;
          return _apolloClient.apolloClient.query({
            query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
            variables: {
              client_id: (0, _auth.getClientID)(),
              file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val
            },
            fetchPolicy: 'no-cache'
          });
        case 2:
          res = _context.sent;
          _context.next = 3;
          return _apolloClient.apolloClient.query({
            query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
            variables: {
              client_id: (0, _auth.getClientID)(),
              file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val
            }
          });
        case 3:
          res1 = _context.sent;
          _context.next = 4;
          return _apolloClient.apolloClient.query({
            query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
            variables: {
              client_id: (0, _auth.getClientID)(),
              file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationAttendance.val
            }
          });
        case 4:
          res2 = _context.sent;
          _context.next = 5;
          return _apolloClient.apolloClient.query({
            query: _clientQuery.GET_CLIENT_DOC_RELEASE_COUNT,
            variables: {
              client_id: (0, _auth.getClientID)(),
              file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationLaborNotice.val
            }
          });
        case 5:
          res3 = _context.sent;
          _context.next = 6;
          return _apolloClient.apolloClient.query({
            query: _recruitmentQuery.GET_RECRUITMENT_ADDSTAFF_COUNT,
            variables: {
              uuid: (0, _auth.getUUID)()
            },
            fetchPolicy: 'no-cache'
          });
        case 6:
          res4 = _context.sent;
          _context.next = 7;
          return _apolloClient.apolloClient.query({
            query: _clientQuery.GET_CLIENT_CHAT_COUNT,
            variables: {
              client_uid: (0, _auth.getUUID)()
            },
            fetchPolicy: 'no-cache'
          });
        case 7:
          res5 = _context.sent;
          if (Number(res.data.client_file_link_aggregate.aggregate.count) !== Number((0, _auth.getContractCount)())) {
            (0, _auth.setContractCount)(res.data.client_file_link_aggregate.aggregate.count);
            find = true;
          }
          if (Number(res1.data.client_file_link_aggregate.aggregate.count) !== Number((0, _auth.getInvoiceCount)())) {
            (0, _auth.setInvoiceCount)(res1.data.client_file_link_aggregate.aggregate.count);
            find = true;
          }
          if (Number(res2.data.client_file_link_aggregate.aggregate.count) !== Number((0, _auth.getAttendanceCount)())) {
            (0, _auth.setAttendanceCount)(res2.data.client_file_link_aggregate.aggregate.count);
            find = true;
          }
          if (Number(res3.data.client_file_link_aggregate.aggregate.count) !== Number((0, _auth.getLaborCount)())) {
            (0, _auth.setLaborCount)(res3.data.client_file_link_aggregate.aggregate.count);
            find = true;
          }
          if (Number(res4.data.recruitment_info_aggregate.aggregate.count) !== Number((0, _auth.getRecruitmentAddStaffCount)())) {
            (0, _auth.setRecruitmentAddStaffCount)(res4.data.recruitment_info_aggregate.aggregate.count);
            find = true;
          }
          if (Number(res5.data.client_message_aggregate.aggregate.sum.unread_count) !== Number((0, _auth.getClientChatCount)())) {
            (0, _auth.setClientChatCount)(res5.data.client_message_aggregate.aggregate.sum.unread_count);
            find = true;
          }
          return _context.abrupt("return", find);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _checkReadingFlag.apply(this, arguments);
}